import React from 'react'
import { classNames, store } from '@dt/fe-utils'
import ENV from '@env'
import './index.scss'

interface IProps {
  className?: string;
  checked: boolean;
  onCheck: () => void;
}

const AgreementCheck = ({ className, checked, onCheck }: IProps) => {
  const handleToLink = (pageUrl = 'getUserClause') => () => {
    const brandInfo = store.get(`ls.brandInfo.${Config.BRANDID}`)
    window.location.href = `${ENV.gateWayUrl}/memberservice/open/${pageUrl}?brandId=${Config.BRANDID}&brandName=${brandInfo?.brandName}`
  }
  return (
    <div className={classNames('agreement-check', className)}>
      <i className={`agreement-check-icon iconfont icon-${checked ? 'checked' : 'uncheck'}`} data-cypid='agreementCheck' onClick={onCheck} />
      <div className='agreement-check-tip'>
        <span data-cypid='agreementCheck' onClick={onCheck}>我已阅读并同意</span>
        <span data-cypid='agreementCheckTipLink' className='agreement-check-tip-link' onClick={handleToLink('getUserClause')}>《用户协议》</span>、
        <span data-cypid='agreementCheckTipLink' className='agreement-check-tip-link' onClick={handleToLink('getPrivateClause')}>《隐私政策》</span>
        <span data-cypid='agreementCheck' onClick={onCheck}>中全部条款</span>
      </div>
    </div>
  )
}

export default AgreementCheck
